module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Gaspard","amd":"gaspard","commonjs":"common-gaspard","commonjs2":"common-gaspard"}
// module id = 1
// module chunks = 0